import { Dispatch } from "../../controller";
import { Item, TabelaPrecoItem } from "../../data.types";
import { Model,StateProps } from "../../model";

export type { Item } from "../../data.types";

export interface ItemState extends StateProps<Item> {
    tabela_preco_selected:TabelaPrecoItem
}

export interface ItemActions extends Dispatch<Item> {
    setTabelaPrecoSelected:(tabela:TabelaPrecoItem)=>any
}

const model = new Model<Item,ItemState>("item");

const intialValueItem:Item = {
    ...model.getInitialValue(),
    type:"item",
    descricao:"",
    codigo:"",
    custo:0,
    detalhes:"",
    comissao:0,
    qt_max_estoque:0,
    _attachments:undefined,
    ativo:true,
    tabela_preco: [],
    info_dt_validade:false,
    convenio_preco:{
        convenios:[],
        valor_mp_cond:[]
    }
}

export const initialValueState:ItemState = {
    ...model.getInititalValueState(),
    row:intialValueItem,
    tabela_preco_selected:{} as TabelaPrecoItem
}


